import PropTypes from "prop-types";
import Header from "../components/Header/Header";

export default function NavigationLayout({ children }) {
  return (
    <>
      <Header />
      <div className="navigation-layout">{children}</div>
    </>
  );
}
NavigationLayout.propTypes = {
  children: PropTypes.node,
};
